"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundMessageType = void 0;
var InboundMessageType;
(function (InboundMessageType) {
    InboundMessageType["Validate"] = "validate";
    InboundMessageType["GetPublicData"] = "getPublicData";
    InboundMessageType["Tokenize"] = "tokenize";
    InboundMessageType["Save"] = "saveCard";
    InboundMessageType["Update"] = "updateCard";
    InboundMessageType["FocusInvalidField"] = "focusInvalidField";
    InboundMessageType["ForceShowSavedCardCVV"] = "forceShowSavedCardCVV";
})(InboundMessageType = exports.InboundMessageType || (exports.InboundMessageType = {}));
//# sourceMappingURL=InboundMessageType.js.map